// Analytics
export const ANALYTICS_LABEL = 'Cards Vertical Scroll Module';

// Mobile constants
export const CLOSED_CARD_HEIGHT = 68;
export const CARD_OVERLAP = 24;
export const NAV_HEIGHT = 64;
export const DEFAULT_DISCLOSURE_BANNER_HEIGHT = 0;
export const DEFAULT_MAX_MOBILE_CARD_HEIGHT = 440;

// Desktop constants
// Controls scroll distance per card (in viewport height units)
export const DESKTOP_SCROLL_HEIGHT_PER_CARD_VH = 60;
